/**
 * Form to Display component
 * This component is a check to see if the setting "Form to display" has been selected.
 * If it has, then we render the block instead of the shortcode (legacy)
 * 
 * This essentially acts as a lookup table to get the component.
 */
import React from "react"
import BinCollection from "../../forms/bincollection";
import CareCostCalculator from "../../forms/cost-care-calculator"
import PlanningInfoMap from "../../forms/planninginformation"
import _ from "lodash"
function Form(data) {
   
     if(!_.isNil(data.data)) {
        //console.log(data.data)
        let FormToDisplay;
    
        if(data.data == 'bincollection') { 
            FormToDisplay = <BinCollection/>
        } else if(data.data == 'asc-calculator') {
            FormToDisplay = <CareCostCalculator/>
        } else if(data.data == 'buildingdevelopment-info') {
            FormToDisplay = <PlanningInfoMap/>;
        } else {
            FormToDisplay = '';
        }
        
            return ( 
                <div id="form-component" className="mbottom-20">
                    {FormToDisplay}
                </div>
            )

      
    } else {
      return null
    }
    
}
export default Form